var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.71 81.79"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-right-large_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-large_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arrow-right-large_svg__cls-1",
    d: "M49.73 0l-6.82 7.32 30.73 28.57H0v10h73.66L42.91 74.46l6.82 7.33L93.71 40.9 49.73 0z",
    id: "arrow-right-large_svg__FOOTER"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5My43MSA4MS43OSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJGT09URVIiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSI0OS43MyAwIDQyLjkxIDcuMzIgNzMuNjQgMzUuODkgMCAzNS44OSAwIDQ1Ljg5IDczLjY2IDQ1Ljg5IDQyLjkxIDc0LjQ2IDQ5LjczIDgxLjc5IDkzLjcxIDQwLjkgNDkuNzMgMCIvPjwvZz48L2c+PC9zdmc+";
export { SvgArrowRightLarge as ReactComponent };